import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IGroupConditionUpdateFragment } from 'graphql/types';

interface IProps {
    groupConditions: IGroupConditionUpdateFragment[];
}

export const GroupConditionsSection = ({ groupConditions }: IProps) => {
    const [translate] = useTranslation();

    return (
        <>
            {groupConditions.map((groupCondition, groupConditionIndex) => {
                const showAndText =
                    groupConditionIndex > 0 &&
                    groupConditionIndex <= groupConditions.length - 1;

                return (
                    <Typography key={groupCondition.id}>
                        {showAndText && (
                            <>
                                {translate(
                                    'offerEventDetail.groupConditions.and'
                                )}{' '}
                            </>
                        )}

                        {groupCondition.groups.edges
                            .map((groupEdge) => groupEdge?.node?.name)
                            .filter(Boolean)
                            .join(', ')}
                    </Typography>
                );
            })}
        </>
    );
};
